// @ts-check
import { DateFilterService } from '@bto-services/utils';
import TopEventsMatchesOddsModel from './top-events-match-odds.model';
import TopEventsMatchesOutcomeModel from './top-events-match-outcome.model';
import { COMBINED_SLIDER_ENUMS } from '../combined-slider/const';

export default class TopEventsMatchModel {
  /**
   * class constructor method
   * @param {import('./interface').ApiTopEvents} data
   */
  constructor(data) {
    /**
     * Home team name
     * @type {string}
     */
    this.homeTeam = data.ht;
    /**
     * Home team Icon, we get this info from betradar
     * @type {string}
     */
    this.homeTeamIcon = data.hti ? `${APP_SETTINGS.path.teamImageUrl}${data.hti}` : '';
    /**
     * Guest team name
     * @type {string}
     */
    this.guestTeam = data.at;
    /**
     * Guest team Icon, we get this info from betradar
     * @type {string}
     */
    this.guestTeamIcon = data.ati ? `${APP_SETTINGS.path.teamImageUrl}${data.ati}` : '';
    /**
     * Sport ID
     * @type {number}
     */
    this.sportId = data.sid;
    /**
     * Sport Name
     * @type {string}
     */
    this.sportName = data.sn;
    /**
     * Sport -> Category ID
     * @type {number}
     */
    this.categoryId = data.cid;
    /**
     * Sport -> Category
     * @type {string}
     */
    this.categoryName = data.cn;
    /**
     * Sport -> Category -> Tournament ID
     * @type {number}
     */
    this.tournamentId = data.tid;
    /**
     * Sport -> Category -> Tournament
     * @type {string}
     */
    this.tournamentName = data.tn;
    /**
     * Sport -> Category -> Tournament -> Match ID
     * @type {number}
     */
    this.matchId = data.mid;
    /**
     * Match ID from betradar
     * @type {string}
     */
    this.betRadarId = data.brid;
    /**
     * event code for the match
     * @type {number}
     */
    this.eventCode = data.ec;
    /**
     * Flag if match is eligible for cashout
     * @type {boolean}
     */
    this.cashoutAvailable = data.cs;
    /**
     * Match date (converted to local date)
     * @type {string}
     */
    this.date = DateFilterService.localDate(data.d, 'datetime', APP_SETTINGS.formatting.shortDateFormat, APP_SETTINGS.formatting.shortTimeFormat);
    /**
     * Match Odds + Odds->Outcomes
     * @type {TopEventsMatchesOddsModel[]}
     */
    this.odds = mapOdds(data.o, data.ht, data.at);
    /**
     * Suspended match
     * @type {boolean}
     */
    this.suspended = data.su;
    /**
     * is tournament US
     * @type {boolean}
     */
    this.isUS = data.tus;
    /**
     * Match name
     * @type {string}
     */
    this.name = getName(data);
    /**
     * Background image
     * @type {string}
     */
    this.backgroundImage = data.i;
    /**
     * Match type
     * Prematch = 1 / Live = 2 / Both = 3
     * @type {number}
     */
    this.matchType = data.mty;
    /**
     * Flag if the top event match is live (available in signalr)
     * @type {boolean}
     */
    this.matchIsLive = false;
    /**
    * Order number
    * @type {number}
    */
    if (data.on) {
      this.orderNumber = data.on;
    }
    /**
     * Type
     * @type { typeof COMBINED_SLIDER_ENUMS.TOP_EVENTS }
     */
    this.type = COMBINED_SLIDER_ENUMS.TOP_EVENTS;
  }

}

/**
 * 
 * @param {import('./interface').ApiTopEvents} data 
 * @returns 
 */
function getName(data) {
  if (data.tus) {
    return `${data.at} @ ${data.ht}`;
  }
  return `${data.ht} vs ${data.at}`;
}

/**
 * 
 * @param {import('./interface').ApiTopEvents['o']} oddsList 
 * @param {string} homeTeam 
 * @param {string} guestTeam 
 * @returns {TopEventsMatchesOddsModel[]} 
 */
function mapOdds(oddsList, homeTeam, guestTeam) {
  if (!oddsList) {
    return [];
  }
  let odds = [];
  oddsList.forEach((o) => {
    let odd = new TopEventsMatchesOddsModel(o, homeTeam, guestTeam);
    if (o.m !== null) {
      /**@type {TopEventsMatchesOutcomeModel[]} */
      let outcomes = o.m.map((m) => new TopEventsMatchesOutcomeModel(m, homeTeam, guestTeam));
      outcomes.sort((a, b) => a.column - b.column);
      odd.outcomes = outcomes;
    }
    odds.push(odd);
  });
  return odds;
}